/**
 * Remove an optimistic user/assistant pair by their temporary client IDs.
 * Used when a stream is cancelled before the turn becomes durable.
 */
export const removeOptimisticTurn = (
  messages,
  userMessageId,
  assistantMessageId
) => messages.filter(
  (message) => (
    message.id !== userMessageId
    && message.id !== assistantMessageId
  )
);

/**
 * Remove a retryable assistant error and the user turn that immediately led
 * to it. Keeping only the user turn causes the same prompt to appear twice
 * when retry creates a fresh optimistic pair.
 */
export const removeFailedTurn = (messages, errorMessageId) => {
  if (!errorMessageId) {
    return messages.filter((message) => !message.error);
  }

  const errorIndex = messages.findIndex(
    (message) => message.id === errorMessageId
  );
  if (errorIndex < 0) {
    return messages.filter((message) => !message.error);
  }

  let userIndex = -1;
  for (let index = errorIndex - 1; index >= 0; index -= 1) {
    if (messages[index].role === 'assistant') break;
    if (messages[index].role === 'user') {
      userIndex = index;
      break;
    }
  }

  return messages.filter((message, index) => (
    index !== errorIndex
    && index !== userIndex
    && !message.error
  ));
};
